import { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import Brand from '../components/Brand';

function VerifyOtp({ onVerify }) {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state || {};
  const { flow = 'signup', identifier = 'your account', method = 'email', userData = {} } = state;

  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [countdown, setCountdown] = useState(30);
  const inputRefs = useRef([]);

  useEffect(() => {
    if (countdown <= 0) return;
    const t = setTimeout(() => setCountdown(countdown - 1), 1000);
    return () => clearTimeout(t);
  }, [countdown]);

  const handleChange = (index, value) => {
    if (!/^\d?$/.test(value)) return;
    const next = [...otp];
    next[index] = value;
    setOtp(next);
    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
    if (!pasted) return;
    const next = pasted.split('').concat(Array(6 - pasted.length).fill(''));
    setOtp(next);
    inputRefs.current[Math.min(pasted.length, 5)]?.focus();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    const code = otp.join('');
    if (code.length < 4) {
      setError('Please enter the OTP code');
      return;
    }

    if (flow === 'signup') {
      onVerify({
        ...userData,
        identifier,
        method,
        verifiedAt: new Date().toISOString(),
      });
      navigate('/home');
    } else if (flow === 'forgot-password') {
      setSuccess('OTP verified. You can now reset your password.');
      setTimeout(() => navigate('/login'), 1500);
    } else {
      onVerify({ identifier, method, verifiedAt: new Date().toISOString() });
      navigate('/home');
    }
  };

  const handleResend = () => {
    setCountdown(30);
    setOtp(['', '', '', '', '', '']);
    inputRefs.current[0]?.focus();
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <Brand />
        <Link to="/login" className="back-link">
          ← Back
        </Link>
        <h1 className="auth-title">Verify your {method}</h1>
        <p className="auth-subtitle">
          We sent a 6-digit code to <strong style={{ color: '#d1d5db' }}>{identifier}</strong>
        </p>

        {error && <div className="error-msg">{error}</div>}
        {success && <div className="success-msg">{success}</div>}

        <form onSubmit={handleSubmit}>
          <div className="otp-inputs" onPaste={handlePaste}>
            {otp.map((digit, i) => (
              <input
                key={i}
                ref={(el) => (inputRefs.current[i] = el)}
                className="otp-input"
                type="text"
                inputMode="numeric"
                maxLength="1"
                value={digit}
                onChange={(e) => handleChange(i, e.target.value)}
                onKeyDown={(e) => handleKeyDown(i, e)}
              />
            ))}
          </div>

          <button type="submit" className="btn-primary">
            Verify
          </button>
        </form>

        <div className="resend-otp">
          Didn't receive the code?
          {countdown > 0 ? (
            <span style={{ marginLeft: 4 }}>Resend in {countdown}s</span>
          ) : (
            <button type="button" onClick={handleResend}>
              Resend OTP
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default VerifyOtp;
